module.exports = __webpack_public_path__ + "img/flit2go.a2bf9d97.png";